export const TEXTOS_ETAPAS = {
  pt: {
    Etapas: "Etapas",
    Etapa: "Etapa",
    "Nova Etapa": "Nova Etapa",
    "Editar Etapa": "Editar Etapa",
    "Responsável da etapa": "Responsável da etapa",
    "Selecione a etapa...": "Selecione a etapa...",
    "Nenhuma etapa cadastrada": "Nenhuma etapa cadastrada",
    "Sem etapa": "Sem etapa",
    "Tarefas por etapa": "Tarefas por etapa",
    "Distribuição de tickets e tarefas por etapa.": "Distribuição de tickets e tarefas por etapa.",
    "Relatórios de Tickets e Tarefas": "Relatórios de Tickets e Tarefas",
    "Tarefas do Calendário": "Tarefas do Calendário",
    "Tarefas por Etapa": "Tarefas por Etapa",
    "Tarefas por Prioridade": "Tarefas por Prioridade",
    "Tarefas por Responsável": "Tarefas por Responsável",
    "Imprimir tarefas": "Imprimir tarefas",
    "Etapas de trabalho e seus responsáveis.": "Etapas de trabalho e seus responsáveis.",
    "Nenhuma tarefa encontrada": "Nenhuma tarefa encontrada",
    "Ajuste a busca ou cadastre uma tarefa no Calendário.": "Ajuste a busca ou cadastre uma tarefa no Calendário.",
  },
  en: {
    Etapas: "Stages",
    Etapa: "Stage",
    "Nova Etapa": "New Stage",
    "Editar Etapa": "Edit Stage",
    "Responsável da etapa": "Stage owner",
    "Selecione a etapa...": "Select a stage...",
    "Nenhuma etapa cadastrada": "No stages registered",
    "Sem etapa": "No stage",
    "Tarefas por etapa": "Tasks by stage",
    "Distribuição de tickets e tarefas por etapa.": "Distribution of tickets and tasks by stage.",
    "Relatórios de Tickets e Tarefas": "Ticket and Task Reports",
    "Tarefas do Calendário": "Calendar Tasks",
    "Tarefas por Etapa": "Tasks by Stage",
    "Tarefas por Prioridade": "Tasks by Priority",
    "Tarefas por Responsável": "Tasks by Owner",
    "Imprimir tarefas": "Print tasks",
    "Etapas de trabalho e seus responsáveis.": "Work stages and their owners.",
    "Nenhuma tarefa encontrada": "No task found",
    "Ajuste a busca ou cadastre uma tarefa no Calendário.": "Adjust the search or create a task in the Calendar.",
  },
  es: {
    Etapas: "Etapas",
    Etapa: "Etapa",
    "Nova Etapa": "Nueva Etapa",
    "Editar Etapa": "Editar Etapa",
    "Responsável da etapa": "Responsable de la etapa",
    "Selecione a etapa...": "Seleccione la etapa...",
    "Nenhuma etapa cadastrada": "No hay etapas registradas",
    "Sem etapa": "Sin etapa",
    "Tarefas por etapa": "Tareas por etapa",
    "Distribuição de tickets e tarefas por etapa.": "Distribución de tickets y tareas por etapa.",
    "Relatórios de Tickets e Tarefas": "Informes de Tickets y Tareas",
    "Tarefas do Calendário": "Tareas del Calendario",
    "Tarefas por Etapa": "Tareas por Etapa",
    "Tarefas por Prioridade": "Tareas por Prioridad",
    "Tarefas por Responsável": "Tareas por Responsable",
    "Imprimir tarefas": "Imprimir tareas",
    "Etapas de trabalho e seus responsáveis.": "Etapas de trabajo y sus responsables.",
    "Nenhuma tarefa encontrada": "No se encontró ninguna tarea",
    "Ajuste a busca ou cadastre uma tarefa no Calendário.": "Ajuste la búsqueda o registre una tarea en el Calendario.",
  },
  "zh-CN": {
    Etapas: "阶段",
    Etapa: "阶段",
    "Nova Etapa": "新建阶段",
    "Editar Etapa": "编辑阶段",
    "Responsável da etapa": "阶段负责人",
    "Selecione a etapa...": "选择阶段...",
    "Nenhuma etapa cadastrada": "暂无阶段",
    "Sem etapa": "无阶段",
    "Tarefas por etapa": "按阶段统计任务",
    "Distribuição de tickets e tarefas por etapa.": "按阶段分布工单和任务。",
    "Relatórios de Tickets e Tarefas": "工单和任务报表",
    "Tarefas do Calendário": "日历任务",
    "Tarefas por Etapa": "按阶段统计任务",
    "Tarefas por Prioridade": "按优先级统计任务",
    "Tarefas por Responsável": "按负责人统计任务",
    "Imprimir tarefas": "打印任务",
    "Etapas de trabalho e seus responsáveis.": "工作阶段及其负责人。",
    "Nenhuma tarefa encontrada": "未找到任务",
    "Ajuste a busca ou cadastre uma tarefa no Calendário.": "调整搜索条件或在日历中创建任务。",
  },
} as const;
